import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "num"
}
const _hoisted_2 = { class: "name" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SourceIcon = _resolveComponent("SourceIcon")
  const _component_SourceType = _resolveComponent("SourceType")
  const _component_SourceWrap = _resolveComponent("SourceWrap")
  const _component_SourcePopover = _resolveComponent("SourcePopover")

  return (_openBlock(), _createBlock(_component_SourcePopover, {
    ref: "popover",
    width: "32.1rem",
    data: $props.data,
    disabled: $props.disabled,
    onHide: _cache[0] || (_cache[0] = $event => ($data.popup_visible = false)),
    onShow: _cache[1] || (_cache[1] = $event => ($data.popup_visible = true))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_SourceWrap, {
        focused: $data.popup_visible,
        class: _normalizeClass(["source-item", {internal: $options.internal}])
      }, {
        default: _withCtx(() => [
          ($options.type !== 'genrate')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString($props.num), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_SourceIcon, { data: $props.data }, null, 8 /* PROPS */, ["data"]),
          _createElementVNode("div", _hoisted_2, _toDisplayString($options.name), 1 /* TEXT */),
          _createVNode(_component_SourceType, { type: $options.type }, null, 8 /* PROPS */, ["type"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["focused", "class"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["data", "disabled"]))
}